import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Input,
  Row,
  Card,
  Form,
  Col,
  Typography,
  Button,
  DatePicker,
  notification,
  Modal,
  Select,
  message,
} from "antd";
import dayjs from "dayjs";
import { StyledAlert } from "../../styles";
import actions from "../../redux/donorDetails/actions";
import config from "../../Services/apiEndPoints";
import "../../Screens/form.css";
import "../MyDonations/datePicker.css";
import axiosInstance from "../../Services/axiosIntercepter";
import { CloseOutlined } from "@ant-design/icons";

const { Option } = Select;
const { TextArea } = Input;

export default function Donate() {
  const dispatch = useDispatch();
  const [razorpayScriptLoaded, setRazorpayScriptLoaded] = useState(false);
  const [donationsForm] = Form.useForm();
  const [donationType, setDonationType] = useState("");
  const navigate = useNavigate();
  const donorId =
    localStorage.getItem("donorId") || sessionStorage.getItem("donor-Id");

  const { successMessage, errorMessage, isFetching, actionType } = useSelector(
    (state) => state.donor,
  );
  const mobileNum = localStorage.getItem("mobileNumber");
  const typeOfUser =
    sessionStorage.getItem("typeOfUser") || localStorage.getItem("typeOfUser");

  const today = dayjs();
  // If today is Sunday, set default date to today
  const defaultDate = today.day() === 0 ? today : null;

  const typeOfDonationsList = [{ label: "Annadanam" }, { label: "Festival" }];

  useEffect(() => {
    if (actionType === actions.DONATION_DETAILS_CREATE_SUCCESS) {
      notification.success({
        message: successMessage,
      });
      setDonationType("");
      donationsForm.resetFields();
      dispatch(actions.resetDonorPersonalDetails());
    } else if (actionType === actions.DONATION_DETAILS_CREATE_ERROR) {
      notification.success({
        message: errorMessage,
      });
      dispatch(actions.resetDonorPersonalDetails());
    }
  }, [actionType]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;

    script.onload = () => setRazorpayScriptLoaded(true);
    script.onerror = () => console.error("Failed to load Razorpay script");

    document.body.appendChild(script);

    // Cleanup
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const enableFutureSundays = (current) => {
    // Check if the current date is in the future
    const isFuture = current && current.isAfter(dayjs(), "day");
    // Check if the current date is Sunday (0 represents Sunday)
    const isSunday = current && current.day() === 0;

    // Enable only future Sundays (disable all other dates)
    return !(isFuture && isSunday);
  };

  const handleDonatePayment = async () => {
    try {
      const values = await donationsForm.validateFields();
      const mail = localStorage.getItem("email");
      const payload = {
        donorId: donorId,
        amount: values.amount,
        email: mail,
      };
      if (values.amount > 25000) {
        dispatch(actions.sendmail(config.sendmoneyemail, payload));
        const modal = Modal.info({
          title: "",
          width: 650, // Using Ant Design's built-in icon
          maskClosable: false,
          content: (
            <div>
              <StyledAlert
                message="Thank you for your interest! For donations above ₹25,000, please contact the Sri Rama Navami team at sriramanavami@yahoo.com."
                type="info"
              />
            </div>
          ),

          footer: (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Button
                key="confirm"
                type="primary"
                onClick={() => {
                  const data = {
                    ...payload,
                    type: "donor",
                  };

                  dispatch(actions.sendmail(config.sendmoneyemail, data));

                  modal.destroy();
                  message.success("Mail sent successfully!");
                }}
                style={{ width: 80, marginTop: 20 }}
              >
                Send Mail
              </Button>
            </div>
          ),
          onOk() {
            modal.destroy();
          },
          closable: true,
        });
      } else {
        if (!razorpayScriptLoaded) {
          console.error("Razorpay script not loaded yet.");
          return;
        }
        try {
          const values = await donationsForm.validateFields();
          values["donor_id"] = donorId;
          // values["annadanam_date"] = values?.annadanam_date?.toISOString();
          if (values.donation_type) {
            values["donation_type"] = values.donation_type;
          } else {
            values["donation_type"] =
              typeOfUser === "annadhanam" ? "Annadanam" : "Festival";
          }

          if (values.donation_type === "Annadanam") {
            let date = new Date(values?.annadanam_date);
            // Add 5 hours and 30 minutes (IST offset)
            date.setHours(date.getHours() + 5);
            date.setMinutes(date.getMinutes() + 30);

            // Convert to ISO format
            values["annadanam_date"] = date.toISOString();
          }

          const { data } = await axiosInstance.post(`${config.razorPay}`, {
            amount: values.amount, // Amount in subunits (e.g., paise)
            currency: "INR",
            donation_type: values.donation_type,
          });

          const options = {
            key:
              values.donation_type === "Annadanam"
                ? "rzp_live_ZtaFUxUoEpyF29"
                : "rzp_live_fxzBCN5ClNn1Ut", // Your Razorpay Key ID,
            amount: data?.data?.amount,
            currency: data?.data?.currency,
            order_id: data?.data?.orderId, // Razorpay order ID received from the backend
            name: "Payment",
            description: "Integration with Razorpay",
            handler: (response) => {
              notification.success({
                message: "Payment Successful",
              });
              const paymentId = response?.razorpay_payment_id;
              navigate("/paymentsuccess", {
                state: {
                  from: "inSideDashboard",
                  paymentId: paymentId,
                  amount: values.amount, // Entered amount
                  currentDate: dayjs().format("DD-MM-YYYY"),
                },
              });
              values["paymentId"] = response.razorpay_payment_id;
              dispatch(
                actions.createDonationDetails(
                  config.donationDetailsCreate,
                  values,
                ),
              );
            },
            notes: values,
            prefill: {
              name:
                localStorage.getItem("name") || sessionStorage.getItem("name"),
              email:
                localStorage.getItem("email") ||
                sessionStorage.getItem("email"),
              contact: mobileNum,
            },
            theme: {
              color: "#F37254",
            },
          };

          // Create Razorpay instance and open the payment window
          const razorpay = new window.Razorpay(options);
          razorpay.open();
        } catch (error) {
          console.error("Error creating Razorpay order: ", error);
        }
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  useEffect(() => {
    // Push the current state to history to prevent back navigation
    window.history.pushState(null, null, "", window.location.href);

    const handlePopState = () => {
      // This will force the user to stay on the current page
      window.history.pushState(null, null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div>
      <Row justify="center">
        <Card
          style={{
            width: "100%",
            maxWidth: "700px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
            margin: 50,
          }}
        >
          <Typography.Title level={3} style={{ textAlign: "center" }}>
            Donation Details
          </Typography.Title>
          <Form
            form={donationsForm}
            layout="vertical"
            style={{ marginTop: "15px" }}
            initialValues={{ annadanam_date: defaultDate }}
          >
            <Row gutter={24}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="donation_type"
                  label="Type of donation"
                  rules={[
                    { required: true, message: "Donation Type is required." },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select Type of donation"
                    optionFilterProp="label"
                    onSelect={(item) => {
                      setDonationType(item);
                    }}
                  >
                    {typeOfDonationsList.map((item, index) => (
                      <Option key={index} value={item.label} label={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="amount"
                  label="Donation amount"
                  rules={[
                    { required: true, message: "Donation amount is required." },
                    {
                      validator: (_, value) => {
                        const donationType =
                          donationsForm.getFieldValue("donation_type");

                        if (value < 10) {
                          return Promise.reject(
                            new Error("Min donation amount is ₹10."),
                          );
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="Donation amount"
                    className="custom-input"
                    type="number"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col xs={24} sm={12}>
                <Form.Item name="in_the_favor_of" label="In the Name Of">
                  <Input
                    placeholder="Enter In the Name Of"
                    className="custom-input"
                  />
                </Form.Item>
              </Col>
              {donationType === "Annadanam" && (
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Annadanam Date"
                    name="annadanam_date"
                    rules={[
                      {
                        required: donationType === "Annadanam", // Only make it required if "Annadanam" is selected
                        message: "Annadanam date is required.",
                      },
                    ]}
                  >
                    <DatePicker
                      dropdownClassName="custom-datepicker"
                      format="DD-MM-YYYY"
                      disabledDate={enableFutureSundays}
                      style={{ height: "30px", width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>

            {donationType !== "Annadanam" && (
              <Row gutter={20}>
                <Col xs={24}>
                  <Form.Item
                    name="notes"
                    label="Purpose"
                    rules={[{ required: false }]}
                  >
                    <Select
                      className="custom-input"
                      placeholder="Select a purpose type"
                    >
                      <Option value="Donation">Donation</Option>
                      <Option value="Festival Annadanam">
                        Festival Annadanam
                      </Option>
                      <Option value="Manjal Kum-kum">Manjal Kum-kum</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <div style={{ display: "flex", gap: "8px" }}>
                <Button
                  type="primary"
                  onClick={handleDonatePayment}
                  style={{ backgroundColor: "#e69500" }}
                >
                  Make payment
                </Button>
              </div>
            </div>
          </Form>
        </Card>
      </Row>
    </div>
  );
}
